import { LENS_DOCUMENT_VERSION, type LensDocument } from '~/pages/LeLens/document/types';

import type { LensDatasetColumn } from '~/types/leLens';

/** Keep a saved SQL answer as rows, rather than inferring new aggregations from its columns. */
export function sqlAnswerDocument(
  title: string,
  tableTitle: string,
  sql: string,
  columns: Array<LensDatasetColumn>,
): LensDocument {
  const dataset = {
    id: 'answer',
    sql,
    date: null,
    label: tableTitle,
    labels: Object.fromEntries(columns.filter((column) => column.label).map((column) => [column.name, column.label])),
  };
  return {
    version: LENS_DOCUMENT_VERSION,
    title,
    audience: 'internal',
    datasets: [dataset],
    measures: {},
    period: { default: '28d', presets: ['28d'], compare: [] },
    filters: [],
    params: {},
    queries: { answer_rows: { dataset: dataset.id, measures: [], raw: true } },
    page: [[{ id: 'answer_table', title: tableTitle, table: [], query: 'answer_rows' }]],
    views: {},
    display: { numbers: 'full' },
  };
}
